import { render } from "./AddChampionship.vue?vue&type=template&id=00d950ad"
import script from "./AddChampionship.vue?vue&type=script&lang=js"
export * from "./AddChampionship.vue?vue&type=script&lang=js"

import "./AddChampionship.vue?vue&type=style&index=0&id=00d950ad&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__